import {
  ClassificationIds,
  DiversificationIds,
  SubClassificationIds,
} from '@/utils/enums';
import { ClassificationItem } from '../categories.utility';

export interface DefaultPortfolioDiversification {
  DiversificationId: DiversificationIds;
  ChildDiversificationId: DiversificationIds;
}

export const getDefaultDiversification = (
  classificationId: ClassificationItem['ClassificationId'],
  subClassificationId: number | null,
): DefaultPortfolioDiversification | null => {
  switch (classificationId) {
    case ClassificationIds.REAL_ESTATE:
      // Real estate has special sub-classifications for investment-owned properties; route those
      // to the investment real-estate diversification bucket rather than residential.
      const isInvestmentRealEstateSubType =
        subClassificationId === SubClassificationIds.INVESTMENT_OWNED ||
        subClassificationId === SubClassificationIds.INVESTMENT_PARTIALLY_OWNED;
      return {
        DiversificationId: DiversificationIds.OTHER,
        ChildDiversificationId: isInvestmentRealEstateSubType
          ? DiversificationIds.INVESTMENT_REAL_ESTATE
          : DiversificationIds.RESIDENTIAL_REAL_ESTATE,
      };
    case ClassificationIds.PRIVATE_INVESTMENT:
      return {
        DiversificationId: DiversificationIds.ALTERNATIVES,
        ChildDiversificationId: DiversificationIds.PRIVATE_EQUITY,
      };
    case ClassificationIds.PERSONAL_PROPERTY:
      return {
        DiversificationId: DiversificationIds.ALTERNATIVES,
        ChildDiversificationId: DiversificationIds.REAL_ASSETS,
      };
    case ClassificationIds.BANKING:
      return {
        DiversificationId: DiversificationIds.CASH,
        ChildDiversificationId: DiversificationIds.BANK,
      };
    default:
      return null;
  }
};
